import {connect} from 'react-redux';
import Step18 from './Step18';
import {submitStep} from "../../actions/submitStep";

const mapStateToProps = ({
                           regType: {regType},
                           stepPayload: {payload},
                         }) => ({
  regType,
  payload
});

export default connect(
  mapStateToProps,
  {submitStep}
)(Step18);
